module.exports = __webpack_public_path__ + "static/media/puertopenasco.46985004.jpg";